import React from 'react'
import { Bars3Icon, ChevronDoubleLeftIcon, ChevronDoubleRightIcon } from '@heroicons/react/24/outline'
import logo from '../../../assets/images/Logo_mdm.webp'
import { SidebarProps } from '../../../types/layout'
import SidebarMenu from './SidebarMenu'

/**
 * Componente principal del Sidebar
 * Incluye logo, botón de colapsar y menú de navegación
 */
const Sidebar: React.FC<SidebarProps> = ({
  isOpen,
  onClose,
  isCollapsed,
  onToggleCollapse,
}) => {
  return (
    <div
      className={` sidebar-container fixed inset-y-0 left-0 z-50 ${
        isCollapsed ? 'w-14' : 'min-w-52 w-52'
      } bg-white shadow-lg transform ${
        isOpen ? 'translate-x-0' : '-translate-x-full'
      } transition-all duration-300 ease-in-out lg:relative lg:translate-x-0 flex flex-col overflow-visible`}
    >
      {/* Header del Sidebar */}
      <div className="p-3 flex items-center justify-between flex-shrink-0 border-b border-gray-100">
        {!isCollapsed && (
          <img
            src={logo}
            alt="Logo"
            className="w-32 h-auto animate-fade-in"
          />
        )}
        <button
          onClick={onToggleCollapse}
          className="p-2 rounded-lg hover:bg-gray-100 transition-all duration-200 hover:scale-110 active:scale-95"
          aria-label={isCollapsed ? 'Expandir sidebar' : 'Colapsar sidebar'}
        >
          {isCollapsed ? (
            <ChevronDoubleRightIcon className="h-5 w-5 text-gray-600 transition-transform duration-200" />
          ) : (
            <ChevronDoubleLeftIcon className="h-5 w-5 text-gray-600 transition-transform duration-200" />
          )}
        </button>
      </div>

      {/* Menú de navegación */}
      <SidebarMenu isCollapsed={isCollapsed} />

      {/* Botón de cerrar en móvil */}
      <button
        onClick={onClose}
        className="lg:hidden absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-all duration-200 hover:scale-110"
        aria-label="Cerrar menú"
      >
        <Bars3Icon className="h-6 w-6" />
      </button>
    </div>
  )
}

export default React.memo(Sidebar)

